{
  "PROFILE_SETTINGS": {
    "LINK": "Profil ayarları",
    "TITLE": "Profil ayarları",
    "BTN_TEXT": "Profili Güncelle",
    "DELETE_AVATAR": "Profil Resmini Sil",
    "AVATAR_DELETE_SUCCESS": "Profil resmi başarıyla silindi",
    "AVATAR_DELETE_FAILED": "Profil resmi silinirken hata oluştu, lütfen tekrar deneyin",
    "UPDATE_SUCCESS": "Profiliniz başarıyla güncellendi",
    "PASSWORD_UPDATE_SUCCESS": "Şifreniz başarıyla değiştirildi",
    "AFTER_EMAIL_CHANGED": "Profiliniz başarıyla güncellendi, lütfen giriş bilgileriniz değiştiği için tekrar giriş yapın",
    "FORM": {
      "PICTURE": "Profil Resmi",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "E-posta imza resmi",
        "HINT": "E-posta imzalarında kullanılır. {'{{'}email_signature_picture{'}}'} bu resmin URL'siyle değiştirilir (bir resim etiketiyle değil) — imzanızda veya gelen kutusu imzasında bunu resim kaynağı (bir img etiketinin src'si) olarak kullanın. Ayarlanmazsa hiçbir şey eklenmez.",
        "DELETE_SUCCESS": "E-posta imza resmi başarıyla silindi",
        "DELETE_FAILED": "E-posta imza resmi silinirken bir hata oluştu, lütfen tekrar deneyin"
      },
      "AVATAR": "Profil Resmi",
      "ERROR": "Lütfen form hatalarını düzeltin",
      "REMOVE_IMAGE": "Kaldır",
      "UPLOAD_IMAGE": "Resim yükleniyor",
      "UPDATE_IMAGE": "Resmi güncelle",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "E-posta adresiniz kimliğinizdir ve oturum açmak için kullanılır."
      },
      "SEND_MESSAGE": {
        "TITLE": "Mesaj göndermek için kısayol",
        "NOTE": "Tercihinize bağlı olarak Enter veya Cmd/Ctrl+Enter tuşlarından birini seçebilirsiniz.",
        "UPDATE_SUCCESS": "Ayarlarınız başarıyla güncellendi",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Mesajları göndermek için Gönder düğmesine tıklamak yerine Enter tuşuna basarak gönderin."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Mesajları göndermek için Gönder düğmesine tıklamak yerine Cmd/Ctrl + Enter tuşuna basarak gönderin."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Panelinizin görünümünü ve hissini özelleştirin.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Varsayılan",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Panel dili",
          "NOTE": "Kendi panelinizde hesap dilini geçersiz kılın. Hesap varsayılanını kullanmak için boş bırakın.",
          "USE_ACCOUNT_DEFAULT": "Hesap varsayılanını kullan",
          "API_SUCCESS": "Panel diliniz başarıyla güncellendi"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Mesaj Dili",
          "NOTE": "Orijinal mesajların mı yoksa çevirilerinin mi gösterileceğini seçin",
          "ORIGINAL": "Orijinal",
          "TRANSLATED": "Çevrilmiş"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Yapıştırma Davranışı",
          "NOTE": "Mesaj yazarken yapıştırılan içeriğin nasıl işleneceğini seçin",
          "UPDATE_SUCCESS": "Yapıştırma ayarlarınız başarıyla güncellendi",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Tüm biçimlendirmeyi koru",
              "DESCRIPTION": "İçeriği yapıştırırken tablolar, stiller ve diğer HTML öğeleri dahil tüm biçimlendirmeyi koru."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Yalnızca bağlantılı metin",
              "DESCRIPTION": "İçeriği yapıştırırken düz metne dönüştür, ancak tıklanabilir bağlantıları koru."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Yalnızca düz metin",
              "DESCRIPTION": "İçeriği yapıştırırken tüm biçimlendirmeyi kaldır ve düz metne dönüştür."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Yanıt kutusu yüksekliği",
          "NOTE": "Yanıt kutusunun minimum yüksekliğini ekran yüksekliğinin yüzdesi olarak ayarlayın. Yalnızca e-posta konuşmaları için geçerlidir.",
          "UPDATE_SUCCESS": "Yanıt kutusu yükseklik ayarınız başarıyla güncellendi",
          "PERCENT_LABEL": "Yükseklik (ekran yüksekliğinin %'si)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Varsayılan",
              "DESCRIPTION": "Yanıt kutusu küçük başlar ve yazdıkça büyür."
            },
            "CUSTOM": {
              "HEADING": "Özel",
              "DESCRIPTION": "Yanıt kutusu her zaman ekran yüksekliğinin en az seçilen yüzdesi kadardır."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Bir sonraki görüşmeye otomatik geç",
        "NOTE": "Geçerli görüşmeyi çözdükten sonra otomatik olarak bir sonraki açık görüşmeye geç",
        "UPDATE_SUCCESS": "Otomatik geçiş ayarı başarıyla güncellendi"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "İmzanız",
        "DESCRIPTION": "Gönderdiğiniz her e-postanın sonunda görünecek benzersiz bir mesaj imzası oluşturun. Ayrıca satır içi bir resim de ekleyebilirsiniz.",
        "NOTE": "Her gönderdiğiniz mesajın sonunda görünen benzersiz bir mesaj imzası oluşturun. Ayrıca, canlı sohbet, e-posta ve API gelen kutularında desteklenen iç içe bir resim ekleyebilirsiniz.",
        "BTN_TEXT": "İmzanızı kaydedin",
        "API_ERROR": "İmza kaydedilemedi! Tekrar deneyin",
        "API_SUCCESS": "İmza başarıyla kaydedildi",
        "IMAGE_UPLOAD_ERROR": "Resim yüklenemedi! Tekrar deneyin",
        "IMAGE_UPLOAD_SUCCESS": "Resim başarıyla eklendi. İmzayı kaydetmek için lütfen kaydet'e tıklayın",
        "IMAGE_UPLOAD_SIZE_ERROR": "Resim boyutu %{size}MB'dan küçük olmalıdır"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "İmzanız",
        "ERROR": "İmza boş bırakılamaz",
        "PLACEHOLDER": "Kişisel mesaj imzanızı buraya ekleyin."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Parola",
        "NOTE": "Parolanızı güncellemek, giriş bilgilerinizi birden fazla cihazda sıfırlar.",
        "BTN_TEXT": "Şifre değiştir"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Erişim Jetonu",
        "NOTE": "Bu simge, API tabanlı bir entegrasyon oluşturuyorsanız kullanılabilir",
        "COPY": "Kopyala",
        "REGENERATE": "Yeniden oluştur",
        "REGENERATE_SUCCESS": "Erişim jetonu başarıyla yeniden oluşturuldu. Eski jetonu kullanan tüm entegrasyonları güncelleyin.",
        "REGENERATE_CONFIRM_TITLE": "Erişim jetonu yeniden oluşturulsun mu?",
        "REGENERATE_CONFIRM_MESSAGE": "Bu işlem geçerli jetonu geçersiz kılar. Eski jetonu kullanan entegrasyonlar çalışmayı durdurur."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome Uzantısı",
        "NOTE": "Gelen telefon çağrıları hakkında zengin bildirimler almak için chrome uzantımızı yükleyin.",
        "INSTALL_BUTTON": "Uzantıyı yükle",
        "ALREADY_INSTALLED": "Uzantı yüklendi"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Sesli Uyarılar",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Sesi oynat",
        "ALERT_TYPES": {
          "NONE": "Hiç",
          "MINE": "Atanmış",
          "ALL": "Hepsi",
          "ASSIGNED": "Bana atanmış konuşmalar",
          "UNASSIGNED": "Atanmamış konuşmalar",
          "NOTME": "Başkalarına atanmış açık konuşmalar"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "Hiçbiri",
          "ASSIGNED": "Atanmış Konuşmalar",
          "ALL_CONVERSATIONS": "Tüm Konuşmalar"
        },
        "DEFAULT_TONE": {
          "TITLE": "Uyarı tonu:"
        },
        "CONDITIONS": {
          "TITLE": "Uyarı koşulları:",
          "CONDITION_ONE": "Tarayıcı penceresi etkin değilse sadece sesli uyarı gönder",
          "CONDITION_TWO": "Atanmış konuşmaların hepsi okunana kadar her 30 saniyede bir uyarı gönder"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Daha fazla bilgi edinin"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "E-posta Bildirimleri",
        "NOTE": "E-posta bildirim tercihlerinizi buradan güncelleyin",
        "CONVERSATION_ASSIGNMENT": "Bir konuşma bana atanınca e-posta bildirimleri gönder",
        "CONVERSATION_CREATION": "Yeni bir konuşma oluşturulduğunda e-posta bildirimleri gönder",
        "CONVERSATION_MENTION": "Bir konuşmada adım geçtiğinde e-posta bildirimleri gönder",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Atanmış bir konuşmada yeni bir mesaj oluşturulduğunda e-posta bildirimleri gönder",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Katıldığım bir konuşmada yeni bir mesaj oluşturulduğunda e-posta bildirimleri gönder",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "E-Posta",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Uygun kullanıcısı olmayan bir görüşmede yeni bir mesaj oluşturulur",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Görüşme sırasında anlık bildirimlere izin ver",
        "TEST_PUSH": "Test",
        "TESTING": "Test ediliyor...",
        "TEST_PUSH_DESCRIPTION": "Kurulumunuzu doğrulamak için test bildirimleri gönderin",
        "TEST_NOTIFICATION_ERROR": "Test bildirimi gönderilemedi. Lütfen tekrar deneyin.",
        "TEST_LOCAL_TITLE": "Test Bildirimi (Yerel)",
        "TEST_LOCAL_BODY": "Bu, yerel bir tarayıcı bildirimidir. Bunu görüyorsanız tarayıcı bildirimleri çalışıyor demektir!"
      },
      "API": {
        "UPDATE_SUCCESS": "Bildirim tercihleriniz başarıyla güncellendi",
        "UPDATE_ERROR": "Tercihler güncellenirken bir hata oluştu, lütfen tekrar deneyin"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Bildirimler",
        "NOTE": "Bildirim tercihlerinizi buradan güncelleyin",
        "CONVERSATION_ASSIGNMENT": "Bana bir konuşma atandığında anında bildirim gönder",
        "CONVERSATION_CREATION": "Yeni bir konuşma oluşturulduğunda anlık bildirimler gönderin",
        "CONVERSATION_MENTION": "Bir konuşmada adım geçtiğinde anlık bildirimler gönder",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Atanmış bir konuşmada yeni bir mesaj oluşturulduğunda anlık bildirimler gönderin",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Katıldığım bir konuşmada yeni bir mesaj oluşturulduğunda anlık bildirimler gönderin",
        "HAS_ENABLED_PUSH": "Bu tarayıcı için bildirim özelliğini etkinleştirdiniz.",
        "REQUEST_PUSH": "Bildirimlerini etkinleştirin",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profil Resmi"
      },
      "NAME": {
        "LABEL": "Tam adınız",
        "ERROR": "Lütfen geçerli bir tam ad girin",
        "PLACEHOLDER": "Lütfen tam adınızı giriniz"
      },
      "DISPLAY_NAME": {
        "LABEL": "Ekran adı",
        "ERROR": "Lütfen geçerli bir tam ad girin",
        "PLACEHOLDER": "Lütfen bir görünen ad girin, bu görüşmelerde görüntülenecektir"
      },
      "POSITION": {
        "LABEL": "Pozisyon",
        "ERROR": "Lütfen geçerli bir pozisyon girin",
        "PLACEHOLDER": "Lütfen pozisyonunuzu girin"
      },
      "CUSTOM_LINE": {
        "LABEL": "Özel satır",
        "ERROR": "Lütfen geçerli bir özel satır girin",
        "PLACEHOLDER": "Lütfen özel satırınızı girin"
      },
      "AVAILABILITY": {
        "LABEL": "Uygunluk",
        "STATUS": {
          "ONLINE": "Çevrimiçi",
          "BUSY": "Meşgul",
          "OFFLINE": "Çevrimdışı"
        },
        "SET_AVAILABILITY_SUCCESS": "Uygunluk başarıyla ayarlandı",
        "SET_AVAILABILITY_ERROR": "Uygunluk ayarlanamadı, lütfen tekrar deneyin"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Konuşma listesinde e-posta önizleme biçimi",
        "NOTE": "E-posta gelen kutularından gelen konuşmalar için konuşma listesinde nelerin gösterileceğini seçin",
        "SUBJECT": "Konu",
        "SUBJECT_WITH_NOTE": "Konu ve, bir Özel Not ise, son mesaj",
        "UPDATE_SUCCESS": "E-posta önizleme ayarı başarıyla güncellendi"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Klavye kısayollarını devre dışı bırak",
        "NOTE": "Uygulama genelinde tüm klavye kısayollarını kapat",
        "UPDATE_SUCCESS": "Klavye kısayolları ayarı başarıyla güncellendi"
      },
      "FOLDER_ORDER": {
        "TITLE": "Klasör Sırası",
        "NOTE": "Klasörlerin (özel görünümler) kenar çubuğunda görünme sırasını özelleştirin. Yeniden sıralamak için sürükleyip bırakın.",
        "NO_FOLDERS": "Özel klasör bulunamadı. Görüşmelerinizi düzenlemek için klasör oluşturun."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Kenar Çubuğu Yapılandırması",
        "NOTE": "Görüşmeler kenar çubuğunda hangi bölümlerin görüneceğini özelleştirin.",
        "SAVE_BUTTON": "Yapılandırmayı Kaydet",
        "UPDATE_SUCCESS": "Kenar çubuğu yapılandırması başarıyla güncellendi",
        "UPDATE_ERROR": "Kenar çubuğu yapılandırması güncellenirken bir hata oluştu, lütfen tekrar deneyin",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Tüm Görüşmeler",
          "ALL_CONVERSATIONS_DESC": "Kenar çubuğunda Tüm Görüşmeler menü öğesini göster",
          "INBOX": "Gelen Kutusu",
          "INBOX_DESC": "Okunmamış bildirimleri içeren ana gelen kutusunu göster",
          "CONVERSATION_GROUPS": "Bahsedilmeler ve İlgisiz",
          "CONVERSATION_GROUPS_DESC": "Bahsedilmeler ve İlgisiz görüşme gruplarını göster",
          "FOLDERS": "Klasörler",
          "FOLDERS_DESC": "Düzenlenmiş görüşmeler için özel görünümleri (klasörleri) göster",
          "TEAMS": "Ekipler",
          "TEAMS_DESC": "Ekip atamalarına göre filtrelenmiş görüşmeleri göster",
          "CHANNELS": "Gelen kutuları",
          "CHANNELS_DESC": "Gelen kutusuna göre filtrelenmiş görüşmeleri göster",
          "LABELS": "Etiketler",
          "LABELS_DESC": "Etiketlere göre filtrelenmiş görüşmeleri göster"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Telefon ayarları",
        "NOTE": "PBX sisteminize ait giriş bilgilerinizi girin.",
        "USERNAME": "Kullanıcı adı",
        "PASSWORD": "Şifre",
        "SUBMIT": "Kaydet",
        "USERNAME_INVALID": "Kullanıcı adı yalnızca harf, rakam ve . _ - + karakterlerini içerebilir — boşluk veya e-posta adresi kullanılamaz.",
        "API": {
          "USERNAME_INVALID": "Kullanıcı adı geçerli bir SIP kullanıcı adı değil. Yalnızca harf, rakam ve . _ - + karakterlerini kullanın — boşluk veya e-posta adresi kullanılamaz.",
          "USERNAME_TAKEN": "Bu kullanıcı adı bu hesapta başka bir kullanıcı tarafından zaten kullanılıyor."
        }
      },
      "EMAIL": {
        "LABEL": "E-posta Adresiniz",
        "ERROR": "Lütfen geçerli bir e-posta adresi girin",
        "PLACEHOLDER": "Lütfen e-posta adresinizi girin, bu görüşmelerde görüntülenecektir"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Şu anki şifreniz",
        "ERROR": "Lütfen mevcut şifrenizi giriniz",
        "PLACEHOLDER": "Lütfen mevcut şifrenizi giriniz"
      },
      "PASSWORD": {
        "LABEL": "Yeni şifre",
        "ERROR": "Lütfen 6 veya daha uzun bir şifre girin",
        "PLACEHOLDER": "Lütfen yeni bir şifre girin"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Yeni şifreyi onayla",
        "ERROR": "Onay parolası, parolayla eşleşmelidir",
        "PLACEHOLDER": "Lütfen yeni şifrenizi tekrar giriniz"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Durumu Değiştir",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Hata bildir",
    "SELECTOR_SUBTITLE": "Listeden bir hesap seçin",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Hata bildir",
    "DESCRIPTION_LABEL": "Sorun Açıklaması",
    "DESCRIPTION_PLACEHOLDER": "Karşılaştığınız sorunu açıklayın...",
    "SUBMIT": "Raporu gönder",
    "SUBMITTING": "Gönderiliyor...",
    "CANCEL": "İptal",
    "SUCCESS": "Hata raporu başarıyla gönderildi. Teşekkür ederiz!",
    "VALIDATION_ERROR": "Göndermeden önce lütfen sorunu açıklayın"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "gün deneme kaldı.",
    "TRAIL_BUTTON": "Şimdi satın al",
    "DELETED_USER": "Silinmiş Kullanıcı",
    "EMAIL_VERIFICATION_PENDING": "Görünüşe göre E-Posta adresinizi henüz doğrulamadınız. Lütfen doğrulama e-postası için gelen kutunuzu kontrol edin.",
    "RESEND_VERIFICATION_MAIL": "Doğrulama E-Postasını tekrar gönder",
    "EMAIL_VERIFICATION_SENT": "Doğrulama E-Postası gönderildi. Lütfen gelen kutunuzu kontrol edin.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Hesap Askıya Alındı",
      "MESSAGE": "Hesabınız askıya alındı. Daha fazla bilgi için lütfen destek ekibine ulaşın."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopyala",
      "CODEPEN": "CodePen'de Aç",
      "COPY_SUCCESSFUL": "Kod başarıyla panoya kopyalandı"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Daha Fazla Göster",
      "SHOW_LESS": "Daha Az Göster"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "İndir",
      "UPLOADING": "Yükleniyor...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Bu hikaye artık mevcut değil.",
      "RECORDING_UNAVAILABLE": "Bu kayıt artık mevcut değil.",
      "DELETE_RECORDING": {
        "BUTTON": "Arama kaydını sil",
        "TITLE": "Arama kaydı silinsin mi?",
        "DESCRIPTION": "Bu aramaya ait tüm kayıtlar telefon santralinden kalıcı olarak silinecek ve geri alınamayacak. Aramanın dökümü ve özeti korunur.",
        "CONFIRM": "Sil",
        "SUCCESS": "Arama kaydı silindi",
        "ERROR": "Arama kaydı silinemedi. Lütfen tekrar deneyin."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Haritada Görüntüle"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Gönder"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Doğrulama yapılıyor...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Yeni Gelen Kutusu"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Şu an görüntülüyor:",
    "SWITCH": "Değiştir",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Konuşmalar",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Tüm Görüşmeler",
    "MENTIONED_CONVERSATIONS": "Bahsedilmeler",
    "PARTICIPATING_CONVERSATIONS": "Katılımcılar",
    "UNATTENDED_CONVERSATIONS": "İlgisiz",
    "REPORTS": "Raporlar",
    "SETTINGS": "Ayarlar",
    "CONTACTS": "Kişiler",
    "DATA_ASSISTANT": "Veri Asistanı",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Anasayfa",
    "AGENTS": "Kullanıcılar",
    "AGENT_BOTS": "Botlar",
    "AUDIT_LOGS": "Denetim Kayıtları",
    "WHATSAPP_TEMPLATES": "WhatsApp şablonları",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Gelen kutuları",
    "NOTIFICATIONS": "Bildirimler",
    "CANNED_RESPONSES": "Hazır Yanıtlar",
    "INTEGRATIONS": "Entegrasyonlar",
    "PROFILE_SETTINGS": "Profil ayarları",
    "ACCOUNT_SETTINGS": "Hesap ayarları",
    "APPLICATIONS": "Uygulamalar",
    "LABELS": "Etiketler",
    "CUSTOM_ATTRIBUTES": "Özel Nitelikler",
    "AUTOMATION": "Otomasyon",
    "MACROS": "Kısayollar",
    "TEAMS": "Ekipler",
    "BILLING": "Fatura",
    "CUSTOM_VIEWS_FOLDER": "Klasörler",
    "CUSTOM_VIEWS_SEGMENTS": "Segmentler",
    "ALL_CONTACTS": "Tüm Kişiler",
    "TAGGED_WITH": "Etiketlendi",
    "NEW_LABEL": "Yeni etiket",
    "NEW_TEAM": "Yeni ekip",
    "NEW_INBOX": "Yeni gelen kutusu",
    "REPORTS_CONVERSATION": "Konuşmalar",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Kampanyalar",
    "ONGOING": "Devam Eden",
    "ONE_OFF": "Tek Seferlik",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Kullanıcılar",
    "REPORTS_LABEL": "Etiketler",
    "REPORTS_INBOX": "Gelen kutusu",
    "REPORTS_TEAM": "Ekip",
    "REPORTS_PHONE": "Telefon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Genel Bakış",
    "WALLBOARD_QUEUES": "Kuyruklar",
    "DATA_ASSISTANT_CHAT": "Sohbet",
    "DATA_ASSISTANT_REPORTS": "Raporlar",
    "NO_WAITING_CALLERS": "bekleyen arayan yok",
    "WAITING_CALLERS": "{count} arayan bekliyor",
    "SET_AVAILABILITY_TITLE": "Kendini şu şekilde ayarla",
    "SET_YOUR_AVAILABILITY": "Uygunluk Durumunuzu Ayarlayın",
    "AVAILABILITY_IMPERSONATING": "Bu kullanıcı olarak oturum açıkken kilitli",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Yeni görüşme",
    "DRAFT": "Taslak",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Önizleme",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Yardım Merkezi",
      "ARTICLES": "Articles",
      "CATEGORIES": "Kategoriler",
      "LOCALES": "Yereller",
      "SETTINGS": "Ayarlar",
      "DICTIONARY": "Sözlük"
    },
    "CHANNELS": "Kanallar",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Otomatik olarak çevrimdışı olarak işaretle",
      "INFO_TEXT": "Sistem sizi otomatik olarak çevrimdışı işaretlesin, uygulamayı veya gösterge tablosunu kullanmıyorsanız.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Dokümantasyonu oku"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Engellenen alan adları ve kişiler",
    "DESCRIPTION": "Bu hesap için engellenen e-posta alan adlarının listesi.",
    "NO_BLOCKED_DOMAINS": "Engellenen alan adı bulunamadı.",
    "BLOCKED_CONTACTS_BTN": "Engellenen Kişiler"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Fatura",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Mevcut Plan",
      "PLAN_NOTE": "Şu anda **{plan}** planına **{quantity}** lisans abonesisiniz",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Aboneliğinizi yönetin",
      "DESCRIPTION": "Önceki faturalarınızı görüntüleyin, fatura detaylarınızı düzenleyin veya aboneliğinizi iptal edin.",
      "BUTTON_TXT": "Fatura portalına git"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Yardıma mı ihtiyacınız var?",
      "DESCRIPTION": "Fatura konusunda herhangi bir sorunla karşılaşıyor musunuz? Yardımcı olmak için buradayız.",
      "BUTTON_TXT": "Sohbet et"
    },
    "NO_BILLING_USER": "Fatura hesabınız yapılandırılıyor. Lütfen sayfayı yenileyip tekrar deneyin."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Eyvah! Hiçbir hesap bulunamadı. Devam etmek için yeni bir hesap oluşturun.",
    "NEW_ACCOUNT": "Yeni hesap",
    "SELECTOR_SUBTITLE": "Yeni bir hesap oluştur",
    "API": {
      "SUCCESS_MESSAGE": "Hesap başarıyla oluşturuldu",
      "EXIST_MESSAGE": "Bu Hesap Zaten Mevcut",
      "ERROR_MESSAGE": "Woot Sunucusuna bağlanılamadı, Lütfen daha sonra tekrar deneyin"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Şirket Adı",
        "PLACEHOLDER": "Şirketiniz"
      },
      "SUBMIT": "Gönder",
      "CANCEL": "İptal"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Tüm kısayolları görüntüle",
    "TITLE": {
      "OPEN_CONVERSATION": "Görüşmeyi aç",
      "RESOLVE_AND_NEXT": "Çöz ve bir sonrakine geç",
      "NAVIGATE_DROPDOWN": "Açılır menü öğelerine git",
      "RESOLVE_CONVERSATION": "Görüşmeyi çöz",
      "GO_TO_CONVERSATION_DASHBOARD": "Konuşma Gösterge Tablosuna git",
      "ADD_ATTACHMENT": "Eklenti ekle",
      "GO_TO_CONTACTS_DASHBOARD": "Kişiler Gösterge Tablosuna git",
      "TOGGLE_SIDEBAR": "Kenar çubuğunu aç/kapat",
      "GO_TO_REPORTS_SIDEBAR": "Raporlar kenar çubuğuna git",
      "MOVE_TO_NEXT_TAB": "Konuşma listesinde bir sonraki sekmeye git",
      "GO_TO_SETTINGS": "Ayarlar'a git",
      "SWITCH_TO_PRIVATE_NOTE": "Özel Not'a geç",
      "SWITCH_TO_REPLY": "Yanıt'a geç",
      "TOGGLE_SNOOZE_DROPDOWN": "Snooze açılır menüsünü aç/kapat",
      "AI_ASSIST_MENU": "AI Yardımı",
      "AI_ASSIST_GRAMMAR": "Dilbilgisini düzelt",
      "AI_ASSIST_UNIFY_LANG": "Mesaj dilini birleştir"
    }
  }
}
